import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { createContext, useState } from "react";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import Paragraph from "../../MainComponent/Paragraph";
import AssetsToSupplyHomeTable from "../AssetsToSupplyHomeTable";
import WithdrawPage from "../Withdraw";
import AseetsToBorrowHomeTable from "../AseetsToBorrowHomeTable";
import SupplyHomeTable from "../SupplyHomeTable";
import BorrowsHomeTable from "../BorrowsHomeTable";
import BorrowHome from "../BorrowPage";

const GridWrapper = styled(Grid)`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  height: auto;
  column-gap: 10px;
  row-gap: 20px;
`;
const CardGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  background: linear-gradient(to top, #161616e0, #161616);
  padding: 20px;
  border-radius: 20px;
  min-height: ${(props) => (props.mh ? props.mh : "30vh")};
  z-index: 1;
`;
const RowDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
const Notification = styled.div`
  background-color: #1ac2ff31;
  width: 50%;
  padding: 10px;
  border-radius: 10px;
  column-gap: 5px;
`;

export const HomePageContext = createContext()
const DashboardHome = () => {
  const [homeState, setHomeState] = useState("home");
  return (
    <HomePageContext.Provider value={{homeState, setHomeState}}>
    <>
      {homeState === "home" ? (
        <>
          <GridWrapper container>
            <CardGrid item xs={12} sm={5.7}>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="left"
                color="#FC9D00"
              >
                Your Supplies
              </SectionsHeading>
              <SupplyHomeTable/>
            </CardGrid>
            {/* ///////////////////////////////////////// */}

            <CardGrid item xs={12} sm={5.7}>
              <SectionsHeading
                fm="PoppinsSB"
                fs="16px"
                fs599="16px"
                ta="left"
                color="#FC9D00"
              >
                Your Borrows
              </SectionsHeading>
              <BorrowsHomeTable />
            </CardGrid>

            {/* ///////////////////////////////////////// */}

            <CardGrid item xs={12} sm={5.7}>
              <RowDiv>
                <SectionsHeading
                  fm="PoppinsSB"
                  fs="16px"
                  fs599="16px"
                  ta="left"
                  color="#FC9D00"
                >
                  Assets To Supply
                </SectionsHeading>
                <Notification>
                  <Paragraph fs="10px" p="0" ta="left" color="#1AC1FF">
                    Your Ethereum wallet is empty.Purchase or transfer assets.
                  </Paragraph>
                </Notification>
              </RowDiv>
              <AssetsToSupplyHomeTable />
            </CardGrid>
            {/* ///////////////////////////////////////// */}

            <CardGrid item xs={12} sm={5.7}>
            <RowDiv>
                <SectionsHeading
                  fm="PoppinsSB"
                  fs="16px"
                  fs599="16px"
                  ta="left"
                  color="#FC9D00"
                >
                  Assets To Borrow
                </SectionsHeading>
                <Notification>
                  <Paragraph fs="10px" p="0" ta="left" color="#1AC1FF">
                  To borrow you need to supply any asset to be used as collateral.
                  </Paragraph>
                </Notification>
              </RowDiv>
              {/* <Paragraph fs="12px" ta="left" color="#707070">
                Nothing supplied yet
              </Paragraph> */}
              <AseetsToBorrowHomeTable/>
            </CardGrid>
          </GridWrapper>
        </>
      ) : homeState === "withdraw" ?  (
        <WithdrawPage />
      ): (
        <BorrowHome />
      )}
    </>
    </HomePageContext.Provider>
  );
};

export default DashboardHome;
